/* eslint-disable react/jsx-no-target-blank */
import './Footer.css'

const Footer = () => {
  return (
    <footer>
    <div className='container'>
      <div className='row'>
        <div className='col-lg-12'>
          <p>copyright © 2023 Crbrog Gaming  company. All right reserved 
          <br/> Design By : <a href='https://github.com/HossamAbuElhasen' target='_blank'> Hossam Abu Elhasen  </a></p>
        </div>

      </div>
        
    </div>
    </footer>
  )
}

export default Footer
